<template>
  <div>
    <v-card v-if="!loading" class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/courses/index')">mdi-arrow-left</v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>اتصال درس ها به دوره</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="5">
            <v-text-field v-model="needle" label="در عنوان و توضیحات درس جستجو کنید." color="black">
            </v-text-field>
          </v-col>
          <v-col cols="5">
            <v-select color="black" v-model="order" label="نوع ترتیب درس ها را انتخاب کنید" :items="orderItems"
                      item-text="name" @change="getItems"></v-select>
          </v-col>
          <v-col cols="2">
            <v-btn @click="getItems()" class="mt-4" elevation="0" color="info" style="letter-spacing: normal!important">
              جستجو
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-data-table
                align="center"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                item-key="id"
                show-expand
                :headers="headers"
                :items="items"
                :items-per-page="10"
                disable-sort
                expand-icon="mdi-chevron-up"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-spacer></v-spacer>
                  <v-switch
                      v-model="singleExpand"
                      label="فقط یک سطر باز شود."
                      class="mt-2"
                  ></v-switch>
                  <v-btn elevation="0" color="success" @click="assign()" style="letter-spacing: normal"
                         class="mb-2 mx-16">تایید اتصال درس ها به دوره
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-row>
                    <v-col cols="12">توضیحات :
                      {{ item.description }}
                    </v-col>
                  </v-row>
                </td>
              </template>
              <template
                  v-slot:[`item.cover`]="{ item }">
                <img :src="item.cover" height="150" width="150" :alt="item.title">
              </template>
              <template
                  v-slot:[`item.select`]="{ item }">
                <div class="d-inline-flex">
                  <v-checkbox color="black" v-model="selectedItemIds[item.id]">
                  </v-checkbox>
                  <v-icon class="mx-8" @click="openFiles(item.id)">mdi-eye</v-icon>
                </div>

              </template>
              <template
                  v-slot:[`item.visibility`]="{ item }">
                <span v-if="item.visibility">قابل مشاهده</span>
                <span v-else>مخفی</span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-progress-circular
        v-else
        :rotate="360"
        :size="200"
        :width="15"
        color="success"
        style="position:fixed!important ; z-index: 10 ; top:35vh!important ; left:49vw!important;"
    >
      لطفا منتظر باشید.
    </v-progress-circular>
  </div>
</template>

<script>
export default {
  name: "CourseItemRelations",
  data() {
    return {
      loading:false,
      courseId: null,
      items: [],
      selectedItemIds: [],
      expanded: [],
      singleExpand: false,
      headers: [
        {text: 'شناسه', value: 'id', align: 'center', width: '2%'},
        {text: 'دسته بندی', value: 'category_name', align: 'center', width: '20%'},
        {text: 'عنوان', value: 'title', align: 'center', width: '10%'},
        {text: 'وضعیت نمایش', value: 'visibility', align: 'center', width: '10%'},
        {text: 'اولویت', value: 'order', align: 'center', width: '3%'},
        {text: 'کاور', value: 'cover', align: 'center'},
        {text: 'تاریخ ساخت', value: 'created_at_fa', align: 'center'},
        {text: 'انتخاب', value: 'select', align: 'right', width: '10%'},
      ],
      needle: null,
      orderItems: [
        {name: 'بر اساس دسته بندی', value: 'category_id'},
        {name: 'بر اساس وضعیت نمایش', value: 'visibility'},
        {name: 'بر اساس اولویت', value: 'order'},
        {name: 'بر اساس زمان ساخت', value: 'created_at'},
      ],
      order: 'created_at',
    }
  },
  methods: {
    openFiles(id) {
      let baseUrl = process.env.VUE_APP_FRONT_URL
      window.open(baseUrl + 'items/item-files/order/' + id, "", "width:800,height=800")
    },
    getItems() {
      let url = 'course/item/index?per_page=10000'
      if (this.needle) {
        url = url + '&needle=' + this.needle
      }
      if (this.order) {
        url = url + '&order=' + this.order
      }
      window.axios.get(url).then((res) => {
        this.items = res.data.data.data
      })
    },
    getCourseItems() {
      window.axios.get('course/crud/get-items/' + this.courseId).then((res) => {
        res.data.data.forEach((itemId) => {
          this.$set(this.selectedItemIds, itemId, true)
        })
      })
    },
    assign() {
      this.loading = true
      window.axios.post('course/crud/assign/' + this.courseId, {
        item_ids: this.selectedItemIds
      }).then(() => {
        this.openSnackbar('درس های انتخاب شده به دوره متصل شد.', 'success')
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted() {
    this.courseId = this.$route.params.id
    this.getItems()
    this.getCourseItems()
  }
}
</script>

<style scoped>

</style>
